import { useState, useEffect } from "react";
import { P, FF } from "../../styles/tokens";
import { useNavigation } from "../../contexts/NavigationContext";
import { useUI } from "../../contexts/UIContext";

export default function MobileBottomNav() {
  const { view, setView, section, setSection } = useNavigation();
  const { setDukyOpen, setAudioOpen } = useUI();
  const [menuOpen, setMenuOpen] = useState(false);

  // Cerrar menú con Escape
  useEffect(() => {
    if (!menuOpen) return;
    const handler = (e) => { if (e.key === "Escape") setMenuOpen(false); };
    window.addEventListener("keydown", handler);
    return () => window.removeEventListener("keydown", handler);
  }, [menuOpen]);

  const menuItems = [
    { id: "chat", icon: "🐿️", label: "Platicar con Duky", action: () => setDukyOpen(true) },
    { id: "voz", icon: "🎙️", label: "Registrar por voz", action: () => setAudioOpen(true) },
    { id: "manual", icon: "✏️", label: "Ingresar manual", action: () => { setView("mes"); setSection("editar"); } },
  ];

  return (
    <>
      {/* Backdrop del menú */}
      {menuOpen && (
        <div onClick={() => setMenuOpen(false)} style={{ position: "fixed", inset: 0, zIndex: 19, background: "rgba(0,0,0,0.3)" }} />
      )}

      <div style={{ position:"fixed", bottom:"max(16px, env(safe-area-inset-bottom))", left:16, right:16, zIndex:20, background:P.surface, borderRadius:99, boxShadow:"0 8px 32px rgba(0,0,0,0.14), 0 2px 8px rgba(0,0,0,0.08)", display:"flex", alignItems:"center", padding:"8px 8px", border:`1px solid ${P.border}` }}>
        {[
          {id:"inicio",  icon:"📊", label:"Inicio",   active:view==="mes"&&section==="resumen", onClick:()=>{setView("mes");setSection("resumen");}},
          {id:"analisis",icon:"🧠", label:"Análisis", active:view==="mes"&&section==="analisis", onClick:()=>{setView("mes");setSection("analisis");}},
        ].map(btn=>(
          <button data-tour={`tab-${btn.id}`} key={btn.id} onClick={btn.onClick} aria-label={`Ir a ${btn.label}`} aria-current={btn.active?"page":undefined}
            style={{ flex:1, padding:"6px 4px", border:"none", background:"transparent", color: btn.active ? P.ingresos.base : P.textXs, cursor:"pointer", fontFamily:FF, display:"flex", flexDirection:"column", alignItems:"center", gap:3 }}>
            <div style={{ width:44, height:44, borderRadius:99, background: btn.active ? P.ingresos.pastel : "transparent", display:"flex", alignItems:"center", justifyContent:"center", fontSize:17 }}>{btn.icon}</div>
            <span style={{ fontSize:9, fontWeight: btn.active ? 800 : 500, textTransform:"uppercase", letterSpacing:"0.04em" }}>{btn.label}</span>
          </button>
        ))}

        {/* Duky FAB + menú popup */}
        <div style={{ flexShrink:0, display:"flex", flexDirection:"column", alignItems:"center", padding:"0 6px", position:"relative" }}>
          {/* Menú popup */}
          {menuOpen && (
            <div style={{ position:"absolute", bottom:72, left:"50%", transform:"translateX(-50%)", zIndex:21, display:"flex", flexDirection:"column", gap:8, minWidth:230 }}>
              {menuItems.map(item => (
                <button key={item.id} onClick={() => { item.action(); setMenuOpen(false); }}
                  aria-label={item.label}
                  style={{
                    padding:"14px 20px", borderRadius:16, border:`1.5px solid ${P.border}`,
                    background:P.surface, color:P.text, fontFamily:FF, fontSize:14, fontWeight:700,
                    cursor:"pointer", display:"flex", alignItems:"center", gap:12, minHeight:48,
                    boxShadow:"0 4px 16px rgba(0,0,0,0.12)", whiteSpace:"nowrap",
                  }}>
                  <span style={{ fontSize:20 }}>{item.icon}</span> {item.label}
                </button>
              ))}
            </div>
          )}
          <button onClick={() => setMenuOpen(!menuOpen)}
            data-tour="duky-fab" aria-label="Acciones rápidas" aria-expanded={menuOpen} aria-haspopup="menu"
            style={{ width:52, height:52, borderRadius:"50%", background: menuOpen ? P.ingresos.base : "linear-gradient(145deg, #1E293B, #0F1924)", border:`3px solid ${P.surface}`, outline:`2px solid ${menuOpen ? P.ingresos.base : P.ingresos.tint}`, display:"flex", alignItems:"center", justifyContent:"center", fontSize: menuOpen ? 18 : 22, cursor:"pointer", marginTop:-20, marginBottom:2, boxShadow:"0 4px 14px rgba(20,61,46,0.35), 0 8px 24px rgba(20,61,46,0.18)", transition:"all .2s", color: menuOpen ? "#fff" : "inherit" }}>
            {menuOpen ? "✕" : "🐿️"}
          </button>
          <span style={{ fontSize:9, fontWeight:700, color:P.ingresos.base, textTransform:"uppercase", letterSpacing:"0.04em" }}>Duky</span>
        </div>

        {[
          {id:"anual", icon:"📅", label:"Anual", active:view==="anual", onClick:()=>setView("anual")},
          {id:"config", icon:"⚙️", label:"Config", active:view==="config", onClick:()=>setView("config")},
        ].map(btn=>(
          <button data-tour={`tab-${btn.id}`} key={btn.id} onClick={btn.onClick} aria-label={`Ir a ${btn.label}`} aria-current={btn.active?"page":undefined}
            style={{ flex:1, padding:"6px 4px", border:"none", background:"transparent", color: btn.active ? P.ingresos.base : P.textXs, cursor:"pointer", fontFamily:FF, display:"flex", flexDirection:"column", alignItems:"center", gap:3 }}>
            <div style={{ width:44, height:44, borderRadius:99, background: btn.active ? P.ingresos.pastel : "transparent", display:"flex", alignItems:"center", justifyContent:"center", fontSize:17 }}>{btn.icon}</div>
            <span style={{ fontSize:9, fontWeight: btn.active ? 800 : 500, textTransform:"uppercase", letterSpacing:"0.04em" }}>{btn.label}</span>
          </button>
        ))}
      </div>
    </>
  );
}
